import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';

import './index.css';
import App from './App';

import configureUiStore from './hook-store/ui-store';
import configureMapStore from './hook-store/map-store';
import configurePaymentStore from './hook-store/payment-store';
import configureAdReportStore from './hook-store/ad-report-store';
import configureAdminStore from './hook-store/admin-store';

configureUiStore();
configureMapStore();
configurePaymentStore();
configureAdReportStore();
configureAdminStore();

ReactDOM.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
